import { useContext } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import styled from 'styled-components'
import { Check } from 'svgIcons'
import { ExamContext } from '@app.feature/exam/context/ExamContext'
import { ExamSurveyFormFields } from '@app.feature/exam/gsat2024-2/desktop/SectionFive/components/stepFour/schema/examSurveySchema'

interface ChoiceAnswerItemMobileProps {
  label: string
  id: string
  questionSeq: number
  questionId: string
}

const ChoiceAnswerItemMobile = ({
  label,
  id,
  questionId,
  questionSeq,
}: ChoiceAnswerItemMobileProps) => {
  const { handleCheckReservation } = useContext(ExamContext)
  const { register, control, setValue, resetField } =
    useFormContext<ExamSurveyFormFields>()
  const choiceOneQuestionFormKey =
    `question${questionSeq}` as keyof ExamSurveyFormFields['choiceOneQuestions']

  const question = useWatch({
    control,
    name: `choiceOneQuestions.${choiceOneQuestionFormKey}`,
  })

  const handleChangeQuestion = () => {
    handleCheckReservation({
      onReservated: () => {
        setValue(
          `choiceOneQuestions.${choiceOneQuestionFormKey}.questionId`,
          questionId,
        )
      },
      onNotReservated: () => {
        resetField(`choiceOneQuestions.${choiceOneQuestionFormKey}`)
      },
    })
  }

  return (
    <StyledWrapper>
      <input
        type="radio"
        id={`radio-${label}-${id}`}
        defaultChecked={question?.answerId === id}
        value={id}
        {...register(
          `choiceOneQuestions.${choiceOneQuestionFormKey}.answerId`,
          {
            onChange: handleChangeQuestion,
          },
        )}
      />
      <label htmlFor={`radio-${label}-${id}`}>
        <div className="check-item">
          <Check />
        </div>
        <span>{label}</span>
      </label>
    </StyledWrapper>
  )
}

export default ChoiceAnswerItemMobile

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  > label {
    width: 130px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;

    > span {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.63;
      letter-spacing: -0.64px;
      color: #333;
    }

    > .check-item {
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #cccccc;
      border-radius: 5px;
      > svg {
        color: #fff;
      }
    }
  }

  > input {
    display: none;

    &:checked + label {
      > .check-item {
        border: 1px solid #004eff;
        background-color: #004eff;
      }
    }
  }
`
